module.exports = __webpack_public_path__ + "static/hero-b22af257e57edae6914d86ca40d258ec.png";